
import React, { Component } from 'react';
import Moment from 'moment';
import axios from "axios";
const idToken = JSON.parse(localStorage.getItem('okta-token-storage'));

class Addnewdocs extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            ...this.props,          
           file1:null,
           filetarget:null,
           filename:'',
           loading: false,
           fid: parseInt(Moment(new Date()).format("hh") + Moment(new Date()).format("mm") + Moment(new Date()).format("ss")),
           modified:idToken.idToken.claims.name,
           updated: Moment(new Date()).format("yyyy-MM-DDTHH:mm:ss"),
         
        }
        this.onSubmit = this.onSubmit.bind(this)
        this.onChange = this.onChange.bind(this)
        this.onChangeImageHandler = this.onChangeImageHandler.bind(this)
       
    }



    onChange = e => this.setState({ [e.target.name]: e.target.value });
    //onChangeImageHandler1 = e => this.setState({ file1: e.target.files[0] });
  

    onChangeImageHandler = e => {
    e.preventDefault();
    //var file1=null
    this.setState({ file1: e.target.files[0]});
    this.setState({filetarget:e.target.value.replace("C:\\fakepath\\", "")});
   // this.state.responseData.files.push({"fid":this.state.fid, "filename": e.target.value.replace("C:\\fakepath\\", ""),"Modifiedby":this.state.modified,"updated":this.state.updated}); 
    // this.state.responseData.nid=this.state.nid
     console.log(this.state.file1)
   }
    

  // {(this.state.responseData.files).push({"Modifiedby":this.state.modified,"updated":this.state.updated})}

    //onChange={e => setState({ ...this.state.responseData.files[this.state.d], filename: e.target.value })}

    onSubmit = (e) => {
      /*   e.preventDefault();
        e.stopPropagation(); */
        this.setState({ loading: true });
        this.state.responseData.files.push({"fid":this.state.fid, "filename": this.state.filetarget,"Modifiedby":this.state.modified,"updated":this.state.updated}); 
        this.state.responseData.nid=this.state.nid
        axios.post('https://fs3.acl.gov/UpdateNADRCFile', this.state.responseData); 
        //axios.post('https://fs3.acl.gov/UpdateNADRCFile', this.state.responseData);       
        console.log("Test111: ", this.state.file1)
        const formData1 = new FormData();
        console.log("Formdata: ", formData1)
        formData1.append('file1', this.state.file1);
        for (var key of formData1.entries()) {
            console.log(key[0] + ', ' + key[1]);
        }
     //Production
         fetch(process.env.REACT_APP_LOGIC_APP_URL, {
            method: "POST",
            headers: {
                "Content-Type": "multipart/form-data , boundary=?"

            },
            body: formData1
        }) 

        //Staging

        /*   fetch(process.env.REACT_APP_LOGIC_APP_URL, {
            mode: 'no-cors',
            method: "POST",
            headers: {
                "Content-Type": "multipart/form-data , boundary=?"

            },
            body: formData1
        }) */
    };
    render() {
        console.log("passss:", this.props.nid)
        const { loading } = this.state;
        return (

            <div>
                    <div class="row body_content">

                        <div class="row" style={{ width: 100 + "%" }}>
                            <div class="post-content" style={{ width: 90 + "%" }}>
                                <form onSubmit={e => {
                                e.preventDefault();
                                this.onSubmit();
                                e.preventDefault()
                                setTimeout(function () {
                                   e.preventDefault();
                                   window.location.reload();
                               }, 3000)
                                //window.close();
                                //window.location.replace("/edit?id=" + this.state.nid)
                                }
                            }
                                >
                                    <div grid grid-cols-6 gap-6>
                                        <div class="flex flex-wrap -mx-3 mb-6">
                                            <div class="w-full px-3">
                                                <label
                                                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                                    for="grid-first-name"
                                                >
                                                    Resource Title
                                              </label>
                                                <input
                                                    class="appearance-none block w-full bg-gray-200 text-gray-700 border  border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                                    type="text"
                                                    name="title"
                                                    id="title"
                                                    //onChange={this.onChange}
                                                    aria-describedby="title"
                                                    placeholder="Enter Title"
                                                    value={this.state.title}
                                                />
                                            </div>
                                        </div>
                                        
                                        <div class="form-group col-span-4 block text-sm font-semibold text-gray-700 mt-8">

                                            <input type="file" class="form-control-file" id="file1" name="file1" 
                                            
                                            //onChange={e => setState({ ...this.state.responseData.files[this.state.d], filename: e.target.value })}
                                            onChange={this.onChangeImageHandler} 
                                            />
                                        </div>
                                        <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                                         



                                        <button
                                            disabled={loading}
                                            type="submit"
                                            className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                        >
                                            {loading && (
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />
                                            )}
                                            {loading && <span>Uploading</span>}
                                            {!loading && <span>Add</span>}

                                        </button>
                                        </div>

                                    </div>
                                </form>
                            </div>

                        </div>









                    </div >
             
            </div>

        );
    }
}



export default Addnewdocs;

